import * as o from "react";
import t from "../lib/IconBase.es.js";
import m from "../defs/Swap.es.js";
const a = o.forwardRef((e, r) => /* @__PURE__ */ o.createElement(t, { ref: r, ...e, weights: m }));
a.displayName = "SwapIcon";
const s = a;
export {
  s as Swap,
  a as SwapIcon
};
